import {FC} from 'react';

import {PriceWithUsd} from 'components/currency/price-with-usd';
import {QuotedPaymentMethodFragment} from 'generated/graphql';
import {calculatePaymentMethodTotalPriceWithTaxDisplay, QuotedProductPriceFields} from 'utils/quotes/calculator';

interface PaymentMethodTotalPriceWithTaxDisplayProps {
    paymentMethod: QuotedPaymentMethodFragment;
    products: QuotedProductPriceFields[];
    exchangeRate?: number | null;
}

export const PaymentMethodTotalPriceWithTaxDisplay: FC<PaymentMethodTotalPriceWithTaxDisplayProps> = ({
    paymentMethod,
    products,
    exchangeRate,
}) => {
    return (
        <PriceWithUsd
            brlAmount={calculatePaymentMethodTotalPriceWithTaxDisplay(products, paymentMethod)}
            exchangeRate={exchangeRate}
        />
    );
};
